export default "__VITE_ASSET__6df5ac5d__"